import React, { useEffect, useRef, useState } from 'react';

import './Persona.css';
import { useTranslation } from 'react-i18next';
import GenericForm from '../../components/GenericForm';
import { useSelector } from 'react-redux';
import { PersonaColumnList, PersonaFilterValidationSchema } from './PersonaConstants';
import { fetchGetPersonaByDocument, fetchInserPersona } from '../../reducers/personaSlice';
import ForeignField, { SmallForeignField } from '../../components/ForeignField';
import { fetchGetPersona_propiedadByPropiedad, fetchInsertPersona_propiedad } from '../../reducers/persona_propiedadSlice';
import { toast } from 'react-toastify';
import PersonaCard from './PersonaCard';

function PersonaRelacionada(props) {
    const { propiedad } = props;

    const { t } = useTranslation();
    const formRef = useRef();

    const [showPersonaForm, setShowPersonaForm] = useState(false);
    const [personas, setPersonas] = useState([]);
    const [searchDocumento, setSearchDocumento] = useState('');
    const [foundPersona, setFoundPersona] = useState(null);
    const [personType, setPersonType] = useState(null);

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const tipoPersonaField = {
        id: 'persona_propiedad_tipo_persona_id',
        dbname: 'tipo_persona_id',
        label: 'tipo_persona_id',
        visible: true,
        form: true,
        filter: true,
        foreign: {
            table: 'tipo_persona',
            label: 'tipo_persona',
            dbname: 'tipo_personadesc',
            type: 'small'
        },
        onChange: (name, value) => {
            setPersonType(parseInt(value));
        }
    };

    const columnList = PersonaColumnList(logguedUserData.isAdmin);

    columnList.push(tipoPersonaField)

    useEffect(() => {
        if (propiedad)
            initData();
    }, [propiedad]);

    const initData = () => {
        initPersonaPropiedad();
    }

    const initPersonaPropiedad = async () => {
        const response = await fetchGetPersona_propiedadByPropiedad(propiedad.id);
        setPersonas(response.persona_propiedadList);
    }

    const handleAddPersona = async (values) => {
        const inserted = await fetchInserPersona(values);

        const dataToSave = {
            persona_id: inserted.personaId[0],
            propiedad_id: propiedad.id,
            conjunto_id: propiedad.conjunto_id,
            tipo_persona_id: personType
        };

        const response = await fetchInsertPersona_propiedad(dataToSave);
        if (response.persona_propiedadId.length > 0) {
            window.$(`#persona_relacionada_modal_form`).modal('hide');
            toast(t("UPDATED_OK"));
            initPersonaPropiedad();
        }
    }

    const handleOpenForm = () => {
        window.$(`#persona_relacionada_modal_form`).modal('show');
    }

    const handleSearchPersona = async () => {
        const personasResp = await fetchGetPersonaByDocument(searchDocumento);
        if (personasResp?.personaList?.length > 0) {
            setFoundPersona(personasResp?.personaList[0]);
        } else {
            setFoundPersona(null);
            let mustAddPersona = window.confirm('el documento no existe en el sistema, desea crearlo');
            if (mustAddPersona) {
                window.$(`#persona_modal_form`).modal('show');
                window.$(`#persona_relacionada_modal_form`).modal('hide');
            }
        }
    }

    const handleAddFoundPersona = async () => {
        const dataToSave = {
            persona_id: foundPersona.id,
            propiedad_id: propiedad.id,
            conjunto_id: propiedad.conjunto_id,
            tipo_persona_id: personType
        };

        const response = await fetchInsertPersona_propiedad(dataToSave);
        console.log(response);

        if (response.persona_propiedadId.length > 0) {
            window.$(`#persona_relacionada_modal_form`).modal('hide');
            toast(t("UPDATED_OK"));
            initPersonaPropiedad();
        }
    }

    return (
        <div className='persona-relacionada'>
            <div className='box-button'>
                <div className='btn btn-primary' onClick={handleOpenForm}>{t('Add')}</div>
            </div>
            <div className='persona-relacionada-lista'>
                {
                    personas?.map(p => (
                        <PersonaCard
                            key={`persona_relacionada_${propiedad.id}_${p.id}`}
                            persona={p}
                        />
                    ))
                }
            </div>
            <GenericForm
                dataRef={formRef}
                title={'persona'}
                formOpen={showPersonaForm}
                onClose={() => { window.$(`#persona_relacionada_modal_form`).modal('hide'); }}
                columnList={columnList}
                onSubmitForm={handleAddPersona}
                selectedData={{ documento: searchDocumento }}
                validationSchema={PersonaFilterValidationSchema(t)}
            />
            <div
                className="modal"
                id={`persona_relacionada_modal_form`}
                data-bs-backdrop="static"
                tabIndex="-1"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <form className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="backDropModalTitle">{t('buscar_persona')}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3 row">

                                <label htmlFor={`persona_relacionada_modal_form_identificacion`} className="col-md-3 col-form-label">{t("documento")}</label>
                                <div className="col-md-9">
                                    <input
                                        color="tertiary"
                                        type="text"
                                        id={`persona_relacionada_modal_form_identificacion`}
                                        value={searchDocumento}
                                        className="form-control"
                                        placeholder={t('documento')}
                                        onChange={(ev) => { setSearchDocumento(ev.target.value) }}
                                    />

                                </div>
                            </div>
                            <div className='mb-3 row'>
                                {
                                    foundPersona &&
                                    <div>
                                        {t('nombre')}: {foundPersona.nombre1} {foundPersona.nombre2} {foundPersona.apellido1} {foundPersona.apellido2}
                                        <SmallForeignField
                                            config={tipoPersonaField}
                                            defaultValue={personType}
                                            prefix={'persona_relacionada_tipo'}
                                            isFilter={false}
                                        />
                                        <button type="button" className="btn btn-primary" onClick={handleAddFoundPersona}>{t('adicionar')}</button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">
                                {t('close')}
                            </button>
                            <button type="button" className="btn btn-primary" onClick={handleSearchPersona}>{t('buscar')}</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default PersonaRelacionada;